import { GenericStaticallySizedInfoBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/generic-static-height-info-box';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  width: number;
  height: number;
  minHeight?: number; // only considered in modal mode
  x: number;
  y: number;
  id?: string; // todo: remove
  contentTop: ReactNode;
  contentMiddle: ReactNode;
  contentBottom: ReactNode;
}

export function ThreePartInfoBox(props: Props) {
  return (
    <GenericStaticallySizedInfoBox
      minHeight={props.minHeight}
      width={props.width}
      height={props.height}
      x={props.x}
      y={props.y}
    >
      <Main>
        <TopPart>{props.contentTop}</TopPart>
        <MiddlePart>{props.contentMiddle}</MiddlePart>
        <BottomPart>{props.contentBottom}</BottomPart>
      </Main>
    </GenericStaticallySizedInfoBox>
  );
}

const Main = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const TopPart = styled.div`
  flex-grow: 0;
  display: flex;
  flex-direction: column;
`;

const MiddlePart = styled.div`
  flex-grow: 1;
  overflow-y: auto;
`;

const BottomPart = styled.div`
  flex-grow: 0;
`;
